import {RouteDefinition} from "../../../routes"
import {CloudActionsEditScreen} from "./CloudActionsEditScreen"

export const CloudActionsSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/cloud-actions",
        component: CloudActionsEditScreen
    }
]
